import { money } from "./financeUi";

export default function FinanceReports({ trial, pnl, balance }) {
  return (
    <div className="grid gap-5 lg:grid-cols-3">
      {trial && (
        <Report testid="company-trial-balance" title="Trial Balance">
          {trial.rows.map((r) => <Line key={r.account_id} label={r.name} value={r.debit ? `Dr ${money(r.debit)}` : `Cr ${money(r.credit)}`} />)}
          <Total label="Total debit" value={money(trial.total_debit)} />
          <Total label="Total credit" value={money(trial.total_credit)} />
          <p className="text-xs text-muted-foreground">{Math.abs(trial.total_debit - trial.total_credit) < 0.01 ? "Balanced" : "Review required"}</p>
        </Report>
      )}
      {pnl && (
        <Report testid="company-profit-loss" title="Profit & Loss">
          <Section title="Income" />
          {pnl.income.map((r) => <Line key={r.name} label={r.name} value={money(r.amount)} />)}
          <Section title="Expenses" />
          {pnl.expenses.map((r) => <Line key={r.name} label={r.name} value={money(r.amount)} />)}
          <Total label="Total income" value={money(pnl.total_income)} />
          <Total label="Total expense" value={money(pnl.total_expense)} />
          <Total label={pnl.profit >= 0 ? "Net profit" : "Net loss"} value={money(Math.abs(pnl.profit))} />
        </Report>
      )}
      {balance && (
        <Report testid="company-balance-sheet" title="Balance Sheet">
          <Section title="Assets" />
          {balance.assets.map((r) => <Line key={r.name} label={r.name} value={money(r.amount)} />)}
          <Section title="Liabilities & Equity" />
          {balance.liabilities.map((r) => <Line key={r.name} label={r.name} value={money(r.amount)} />)}
          <Total label="Total assets" value={money(balance.total_assets)} />
          <Total label="Total liabilities & equity" value={money(balance.total_liabilities_equity)} />
        </Report>
      )}
    </div>
  );
}

const Report = ({ title, children, testid }) => (
  <div className="bg-card border rounded-xl p-5 space-y-2" data-testid={testid}>
    <h2 className="font-display font-bold">{title}</h2>
    {children}
  </div>
);
const Section = ({ title }) => <div className="pt-2 text-xs font-bold uppercase tracking-wide text-muted-foreground">{title}</div>;
const Line = ({ label, value }) => (
  <div className="flex justify-between text-sm"><span>{label}</span><span className="tabular-nums">{value}</span></div>
);
const Total = ({ label, value }) => (
  <div className="flex justify-between border-t pt-2 text-sm font-semibold"><span>{label}</span><span className="tabular-nums">{value}</span></div>
);
